import { Component } from 'react';

import fastdom from 'fastdom';
import { NO_VALUE } from '../../../utils';

export interface Props {
  value: number;
}

export interface State {
  lastValue: number | null;
  value: number;
}

enum FlashClass {
  down = 'u-downBgFlash',
  up = 'u-upBgFlash',
}

enum NumericalConversionOfSign {
  negativeInt = -1,
  positiveInt = 1,
}

const CellStyles = { padding: '0 6px' };

export default class AnimateChangeRenderer extends Component<Props, State> {
  CELL: HTMLElement | null | undefined;
  lastValue: number | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      lastValue: null,
      ...props,
    };
  }

  refresh({ value }: Props) {
    const fixedValue = value.toFixed(4);
    const className = this.getClassName(this.lastValue, value);
    // remove the classname, then re-add it to re-trigger the css animation
    if (this.CELL) {
      if (this.CELL.className === className) {
        this.CELL.className = '';
        fastdom.mutate(() => {
          if (this.CELL) {
            this.CELL.className = className;
            this.CELL.innerText = `${fixedValue ?? NO_VALUE}`;
          }
        });
      } else {
        this.CELL.className = className;
        this.CELL.innerText = `${fixedValue ?? NO_VALUE}`;
      }
    }

    this.lastValue = value;
    return true;
  }

  getClassName(lastValue: number | null, value: number) {
    const difference = lastValue ? value - lastValue : 0;

    switch (Math.sign(difference)) {
      case NumericalConversionOfSign.positiveInt:
        return FlashClass.up;
      case NumericalConversionOfSign.negativeInt:
        return FlashClass.down;
      default:
        return '';
    }
  }

  render() {
    const className = this.getClassName(this.state.lastValue, this.state.value);
    // remove the classname, then re-add it to re-trigger the css animation
    const value = this.state.value;
    const stateValue = value === undefined || value === null ? value : value.toFixed(4);
    const formattedValue = stateValue ?? NO_VALUE;

    return (
      <div
        className={className}
        ref={ref => {
          this.CELL = ref;
        }}
        style={CellStyles}
      >
        {formattedValue}
      </div>
    );
  }
}
